// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 22.5H2V10.5H22V22.5ZM6 19.5H16V17.5H6V19.5ZM6 15.5H12V13.5H6V15.5ZM8 4.5H16V1.5H18V4.5H22V8.5H2V4.5H6V1.5H8V4.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-calendar-3-filled')
export default class Calendar3FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar-3-filled',
    }
  }
}
